<template>
  <section class="home-hero">
    <b-container>
      <b-row class="align-items-center home-hero__top">
        <b-col lg="6" class="home-hero__intro">
          <h1 class="home-hero__title">{{ $t('pages.home.hero.title') }}</h1>
          <p class="home-hero__lead">{{ $t('pages.home.hero.lead', { appName }) }}</p>
        </b-col>
        <b-col lg="6" class="home-hero__art">
          <b-img
            :src="require('@base/assets/images/svg/home-hero.svg')"
            class="home-hero__illustration"
            alt=""
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" class="mb-3 mb-md-0">
          <div class="role-card">
            <span class="role-card__icon"><b-icon icon="tag" /></span>
            <h2 class="role-card__title">{{ $t('pages.home.role.seller.title') }}</h2>
            <p class="role-card__text">{{ $t('pages.home.role.seller.text') }}</p>
            <div class="role-card__actions">
              <b-button
                v-if="storesUrl"
                variant="primary"
                :href="storesUrl"
              >
                {{ $t('pages.home.role.seller.find_store') }}
              </b-button>
              <b-button
                :variant="storesUrl ? 'outline-secondary' : 'primary'"
                :href="guidesUrl"
                target="_blank"
                rel="noopener"
              >
                {{ $t('pages.home.role.seller.guides') }}
              </b-button>
            </div>
          </div>
        </b-col>
        <b-col md="6">
          <div class="role-card">
            <span class="role-card__icon"><b-icon icon="shop" /></span>
            <h2 class="role-card__title">{{ $t('pages.home.role.store.title') }}</h2>
            <p class="role-card__text">{{ $t('pages.home.role.store.text') }}</p>
            <div class="role-card__actions">
              <b-button variant="primary" :to="{ name: 'admin-login' }">
                {{ $t('pages.home.card2.button') }}
              </b-button>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
  import { APP_NAME } from '@base/configs'

  export default {
    name: 'HomeHero',

    data () {
      return {
        appName: APP_NAME,
      }
    },

    props: {
      storesUrl: {
        type: String,
        default: null,
      },
      guidesUrl: {
        type: String,
        required: true,
      },
    },
  }
</script>

<style scoped>
  .home-hero {
    background: linear-gradient(180deg, var(--ui-brand-soft) 0%, #ffffff 100%);
    padding: 2.5rem 0 2rem;
  }

  .home-hero__top {
    margin-bottom: 2rem;
  }

  .home-hero__intro {
    text-align: center;
    margin-bottom: 1.5rem;
  }

  .home-hero__art {
    display: flex;
    justify-content: center;
  }

  .home-hero__illustration {
    width: 100%;
    max-width: 280px;
    height: auto;
  }

  .home-hero__title {
    font-size: 2rem;
    font-weight: 700;
    line-height: 1.15;
    color: var(--ui-ink);
    margin-bottom: 1rem;
  }

  .home-hero__lead {
    font-size: 1.125rem;
    color: var(--ui-muted);
    max-width: 32rem;
    margin: 0 auto;
  }

  .role-card {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
    border: 1px solid var(--ui-border);
    border-radius: 12px;
    padding: 1.5rem;
    box-shadow: var(--ui-shadow);
  }

  .role-card__icon {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: var(--ui-brand-soft);
    color: var(--ui-brand);
    font-size: 1.35rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
  }

  .role-card__title {
    font-size: 1.25rem;
    font-weight: 700;
    color: var(--ui-ink);
    margin-bottom: 0.5rem;
  }

  .role-card__text {
    color: var(--ui-muted);
    flex: 1;
    margin-bottom: 1.25rem;
  }

  .role-card__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .role-card__actions .btn {
    flex: 1 1 auto;
  }

  @media (min-width: 992px) {
    .home-hero {
      padding: 4.5rem 0 3.5rem;
    }

    .home-hero__top {
      margin-bottom: 3rem;
    }

    .home-hero__intro {
      text-align: left;
      margin-bottom: 0;
      padding-right: 2rem;
    }

    .home-hero__art {
      justify-content: flex-end;
    }

    .home-hero__illustration {
      max-width: 420px;
    }

    .home-hero__title {
      font-size: 2.5rem;
    }

    .home-hero__lead {
      margin: 0;
    }
  }
</style>
